import React from 'react'
import { MoreOutlined } from '@ant-design/icons'
import { Button, Dropdown, Menu, Tag } from 'antd'
import { ColumnFilterItem } from 'antd/lib/table/interface'

import { renderTenantLink } from '../../../components/tables/table-column-renderers'
import { buildSearchFilterProps, sortNumericColumn, sortStringColumn } from '../../../components/tables/utils'
import { ProposedTenant } from '../models'

interface Props {
  onUpdate: (id: number) => void
  tableFilterMenuItems: {
    segmentCodes: ColumnFilterItem[]
  }
}

const renderActionsMenu =
  ({ onUpdate }: { onUpdate?: (tenantId: number) => void }) =>
  (tenant: ProposedTenant) => {
    const menu = (
      <Menu key={tenant.id}>
        <Menu.Item key="updateTenant" onClick={() => onUpdate(tenant.id)}>
          {tenant.acceptanceStatus === 'ACCEPTED' ? 'View' : 'Update'} Customer
        </Menu.Item>
      </Menu>
    )

    return (
      <Dropdown placement="bottomRight" overlay={menu}>
        <Button icon={<MoreOutlined />} />
      </Dropdown>
    )
  }

export const buildTenantsTableColumns = ({ onUpdate, tableFilterMenuItems }: Props) => [
  {
    title: 'Id',
    dataIndex: 'id',
    sorter: sortNumericColumn({ dataIndex: 'id' }),
    ...buildSearchFilterProps({ dataIndex: 'id' }),
  },
  {
    title: 'Name',
    dataIndex: 'customerName',
    sorter: sortStringColumn({ dataIndex: 'customerName' }),
    ...buildSearchFilterProps({ dataIndex: 'customerName' }),
  },
  {
    title: 'Domain',
    dataIndex: 'domain',
    sorter: sortStringColumn({ dataIndex: 'domain' }),
    ...buildSearchFilterProps({
      dataIndex: 'domain',
      render: renderTenantLink,
    }),
  },
  {
    title: 'ABN',
    dataIndex: 'abn',
    sorter: sortStringColumn({ dataIndex: 'abn' }),
    ...buildSearchFilterProps({ dataIndex: 'abn' }),
  },
  {
    title: 'Segment',
    dataIndex: 'segmentCode',
    filters: tableFilterMenuItems.segmentCodes,
    onFilter: (segmentCode: string, record: ProposedTenant) => record.segmentCode.indexOf(segmentCode) === 0,
  },
  {
    title: 'At the platform',
    dataIndex: 'status',
    render: (status) => {
      let color = ''

      if (status === 'NEW') color = 'blue'

      return <Tag color={color}>{displayTenantStatus(status)}</Tag>
    },
  },
  {
    title: 'Acceptance Status',
    dataIndex: 'acceptanceStatus',
    render: (acceptanceStatus) => {
      let color = ''

      if (acceptanceStatus === 'ACCEPTED') color = 'green'
      if (acceptanceStatus === 'REJECTED') color = 'red'

      return <Tag color={color}>{acceptanceStatus}</Tag>
    },
  },
  { title: '', render: renderActionsMenu({ onUpdate }) },
]

const displayTenantStatus = (status) => status === 'DUPLICATE' ? 'EXISTING TENANT' : 'NEW TENANT'
